/**************************************************************/
/*** Fuile: networkSrvice.js	*********************************/
/*** sample request										 	                    ***/
/***                                                       	***/
/*** var request = {url:"http://cvs/myservice", 	          ***/
/***				header:{},							                       	***/
/***				data:{},							                         	***/
/***				onSuccess:callBackSuccess,				              ***/
/***				onError:callBackFailiure				                ***/
/***			}											                            ***/
/*** 													                             	***/
/**************************************************************/
/**************************************************************/

angular.module('cvsApp').service('networkService',['$http','msgManagerService', function(httpService,MMS){

var networkService = function(){
	var self = this;
	self.apiResponse = "";	
  self.get = function(apiPath, headers, onSuccess, OnError) {
    if(typeof(headers) === 'undefined') headers = {};
    return httpRequest('GET', apiPath, headers);
  }

  self.post = function(request) {
    //if(typeof(request.data) === 'undefined') request.data = {};
    if(typeof(request.headers) === 'undefined') request.headers = {};
    return httpRequest('POST', request,request.timeout);
  }

  self.put = function(apiPath, data, headers) {
    if(typeof(data) === 'undefined') data = {};
    if(typeof(headers) === 'undefined') headers = {};
    return httpRequest('PUT', apiPath, headers, data);
  }

  self._delete = function(apiPath, headers) {
    if(typeof(headers) === 'undefined') headers = {};
    return httpRequest('DELETE', apiPath, headers);
  }

  function httpRequest(method, payload,timeOutTime) {
    var httpHeader;
    if(cvsUtility.queryMap.enableHttpTrace == "yes"){
      httpHeader={'pragma':CVS.Config.httpHeader['pragmaHeaderValue']};
		} else{
      httpHeader ={};
    }
    
    payload.header = _.extend(payload.header, httpHeader);
    var request = {
      method: method,
      url: payload.url,
      headers:payload.header,
	   data: payload.data,
      timeout:timeOutTime?timeOutTime:CVS.Config.timeout.default
    };   
    return httpService(request);	
  }

  self.httpError = function (reason){    
      var errror = MMS.errorMsg('QR_SERVER_ERROR') ? MMS.errorMsg('QR_SERVER_ERROR'):MMS.errorMsg('SERVER_ERROR');
      var xgrid = reason.headers()["x-grid"] !== undefined ? reason.headers()["x-grid"] : '';
      return {SERVER_ERROR:true, ERROR_MSG: errror, SERVER_STATUS: reason.status, SERVER_DESC: reason.statusText, XGRID: xgrid };
  }
}
return new networkService();

}]);